module.exports = __webpack_public_path__ + "static/media/Location_Book-Page11.306d86f5.png";